class CartRemoveAllButton extends HTMLButtonElement {
    connectedCallback() {
        this.addEventListener('click', this.removeAll.bind(this));
    }

    async removeAll() {
        this.setAttribute('disabled', '');
        try {
            const root = window.Shopify.routes.root === '/' ? '' : window.Shopify.routes.root;
            let endpoint = `${root}/cart/clear.js`;

            const sectionsToFetch = [];

            // 1. Cart Drawer
            const cartDrawer = document.querySelector('cart-drawer');
            let cartDrawerSectionId = null;
            if (cartDrawer) {
                const section = cartDrawer.closest('.shopify-section');
                if (section) {
                    cartDrawerSectionId = section.id.replace('shopify-section-', '');
                    sectionsToFetch.push(cartDrawerSectionId);
                }
            }

            // 2. Main Cart Page Section
            let mainCartSectionId = null;
            const mainCartSection = document.querySelector('.shopify-section--main-cart');
            if (mainCartSection) {
                mainCartSectionId = mainCartSection.id.replace('shopify-section-', '');
                sectionsToFetch.push(mainCartSectionId);
            }

            if (sectionsToFetch.length > 0) {
                endpoint += `?sections=${sectionsToFetch.join(',')}`;
            }

            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            });

            const cartData = await response.json();


            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                    cart: cartData,
                    baseEvent: 'cart-remove-all'
                }
            }));

            if (mainCartSectionId && cartData.sections && cartData.sections[mainCartSectionId]) {
                const newHtml = cartData.sections[mainCartSectionId];

                const parser = new DOMParser();
                const doc = parser.parseFromString(newHtml, 'text/html');



                mainCartSection.innerHTML = newHtml;
            }

        } catch (e) {
            console.error('Failed to clear cart', e);
            window.location.reload();
        } finally {
            this.removeAttribute('disabled');
        }
    }
}

if (!customElements.get('cart-remove-all-button')) {
    customElements.define('cart-remove-all-button', CartRemoveAllButton, { extends: 'button' });
}
